export const ViewerManagerStructureAPISymbol = Symbol('viewerManagerStructureApi')

export const ComponentStructureFixerSymbol = Symbol('ComponentStructureFixer')
